export interface FAQ {
    id?: string;
    q: string;
    a: string;
}

export interface FAQCategory {
    category: string;
    questions: FAQ[];
}

export const cmaFaqsData: FAQCategory[] = [
    {
        category: "General Questions",
        questions: [
            {
                q: "What is a CMA?",
                a: "The Certified Management Accountant (CMA) is a professional certification credential in the management accounting and financial management fields. The certification signifies that the person possesses knowledge in the areas of financial planning, analysis, control, decision support, and professional ethics."
            },
            {
                q: "Who is IMA?",
                a: "IMA® (Institute of Management Accountants) is the worldwide association of accountants and financial professionals in business. We are one of the largest and most respected associations focused exclusively on advancing the management accounting profession."
            },
            {
                q: "What are the benefits of becoming a CMA?",
                a: "The CMA certification can help you unlock your earning potential, with CMAs earning significantly more than their non-certified peers. It enhances your skills, giving you greater credibility, and provides a pathway to a more successful business career."
            },
            {
                q: "How do I become a CMA?",
                a: "To become a CMA, you must have an active IMA membership, satisfy the education and experience requirements, and pass both parts of the CMA exam."
            }
        ]
    },
    {
        category: "Education Requirement",
        questions: [
            {
                q: "What is the education requirement for the CMA program?",
                a: "You must hold a bachelor's degree from an accredited college or university (or an international equivalent). If you do not have a bachelor's degree, certain professional certifications are also accepted. Please check the IMA website for a full list."
            },
            {
                q: "Can I take the CMA exam before I graduate?",
                a: "Yes, you can sit for the exam before you graduate. However, you must complete your degree requirements before you can be certified."
            },
            {
                q: "How do I submit my educational transcripts?",
                a: "You can email a copy of your transcripts to ale-cpe-educationdocuments@imanet.org or mail them directly to the ICMA."
            }
        ]
    },
    {
        category: "Experience Requirement",
        questions: [
            {
                q: "What is the experience requirement?",
                a: "You must complete two continuous years of professional experience in management accounting and/or financial management. This can be completed before or within seven years of passing the exam."
            },
            {
                q: "What kind of work experience qualifies?",
                a: "Qualifying experience consists of positions requiring judgments to be made employing the principles of management accounting and financial management, such as financial analysis, budget preparation, and internal auditing. Roles that are clerical or non-technical in nature do not qualify."
            },
            {
                q: "Does part-time work count?",
                a: "Yes, part-time positions of at least 20 hours per week can count. Two years of part-time work is equivalent to one year of full-time experience."
            }
        ]
    },
    {
        category: "The Exam",
        questions: [
            {
                q: "What is the structure of the CMA exam?",
                a: "The exam is in two parts. Each part is four hours long and includes 100 multiple-choice questions and two 30-minute essay questions. You must pass the multiple-choice section with a score of 50% or higher to be eligible for the essay section."
            },
            {
                q: "What is the passing score?",
                a: "A score of 360 out of a possible 500 is required to pass each part."
            },
            {
                q: "How long do I have to complete both parts of the exam?",
                a: "Once you enter the CMA program, you must complete both parts of the exam within three years."
            },
            {
                q: "When and where can I take the exam?",
                a: "The exam is offered at Prometric testing centers around the world during three testing windows: January/February, May/June, and September/October."
            }
        ]
    },
    {
        category: "Exam Scheduling & Fees",
        questions: [
            {
                id: "faq-reschedule-fee",
                q: "What are the fees for changing or canceling my CMA exam date?",
                a: "ICMA and Prometric have fees for changes. To transfer to the next testing window, ICMA charges a non-waivable $75 fee, and the request must be made at least five days before your appointment. For rescheduling or canceling within 3 to 30 days of your exam, Prometric charges a $50 fee."
            },
            {
                q: "How do I transfer my exam to the next testing window?",
                a: "You must first cancel your existing appointment with Prometric. Then, submit a request to IMA Member Services at ima@imanet.org no later than five days before your original appointment. A $75 fee applies. If you don't cancel your appointment in time, ICMA cannot process the transfer."
            },
            {
                q: "Can I reschedule my exam within the same testing window?",
                a: "Yes. Prometric allows rescheduling within the same window. They will charge a $50 fee if the change is made between 3 and 30 days of your scheduled test date."
            },
            {
                id: "faq-miss-exam",
                q: "What happens if I miss my exam appointment or cancel too late?",
                a: "If you miss your appointment or cancel within 3 days (72 hours) of the scheduled time, you are considered a 'no-show.' In this case, you will forfeit your entire exam fee and will have to pay again to register for a new exam."
            }
        ]
    },
    {
        category: "After Passing the Exam",
        questions: [
            {
                q: "What happens after I pass both parts of the exam?",
                a: "Once you have passed both parts and your education and experience requirements have been verified, you will receive your CMA certificate and become a Certified Management Accountant."
            },
            {
                q: "How long does it take to get my certificate?",
                a: "After all requirements are met, it typically takes a few weeks to receive your official certificate by mail."
            }
        ]
    },
    {
        category: "Continuing Education Requirement",
        questions: [
            {
                q: "Are there any ongoing requirements to maintain my CMA certification?",
                a: "Yes, CMAs are required to complete 30 hours of Continuing Professional Education (CPE) annually, including a minimum of two hours in the area of ethics."
            },
            {
                q: "How do I report my CPE credits?",
                a: "You can report your CPE credits through your online IMA profile. It is your responsibility to maintain records of your CPE activities."
            }
        ]
    }
];